import {
  TRANSFER_WORK_ORDER_CLIENT_SELECT,
  TRANSFER_WORK_ORDER_MESSAGE_MODAL_SHOW,
  TRANSFER_WORK_ORDER_MODAL_SHOW,
} from 'components/admin/work-orders/details/transfer/store/action-types';
import { workOrdersApi } from 'services/api/work-orders-api';
import { showErrorMessage } from 'actions/messages';
import {
  baseRoutePath,
  updateWorkOrderAttribute,
} from 'actions/admin/work-orders/work-orders';
import { push } from 'react-router-redux';

export function updateGc(workOrderId, gcId) {
  return (dispatch) => {
    const values = { general_contractor_id: gcId };
    return workOrdersApi
      .updateWorkOrder(workOrderId, values)
      .then((response) => {
        if (response.ok) {
          dispatch(
            updateWorkOrderAttribute(response.workOrder, 'general_contractor')
          );
        } else {
          dispatch(showErrorMessage(response.errors));
        }
      });
  };
}

export function changeWorkOrderClient(workOrderId, clientId) {
  return (dispatch) => {
    return workOrdersApi
      .changeClient(workOrderId, clientId)
      .then((response) => {
        if (response.ok) {
          dispatch(setShowModal(false)); // hide client selection modal
          dispatch(setShowMessageModal(true));
        } else {
          dispatch(showErrorMessage(response.errors));
        }
      });
  };
}

export function finishTransfer() {
  return (dispatch) => {
    dispatch(setShowMessageModal(false));
    dispatch(push(baseRoutePath));
  };
}

export function selectClient(client) {
  return {
    type: TRANSFER_WORK_ORDER_CLIENT_SELECT,
    payload: client,
  };
}

function setShowMessageModal(value) {
  return {
    type: TRANSFER_WORK_ORDER_MESSAGE_MODAL_SHOW,
    payload: value,
  };
}

export function setShowModal(value) {
  return {
    type: TRANSFER_WORK_ORDER_MODAL_SHOW,
    payload: value,
  };
}



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/transfer/store/actions.js